import { Box, TextField, Tooltip } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import React from 'react';
import PropTypes from 'prop-types';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import IconButtonBadge from '../../shared/ui/IconButtonBadge/IconButtonBadge';
import DeleteButton from '../../shared/ui/DeleteButton/DeleteButton';
import style from './GeoZonesToolbarWidget.module.css';
import ExportDataBySensors from '../../features/export/ExportDataBySensors/ExportDataBySensors';
import ImportGeoZoneButton from './components/components/ImportGeoZone/button';
import ExportGeoZone from './components/components/ExportGeoZone';

const DRAW_FREEHAND_KEY = 'Shift + Нажатая левая кнопка мыши';
const DRAW_FREEHAND_HINT = 'Рисовать границы непрерывно(от руки)';

const DELETE_POINT_KEY = 'Alt + Левая кнопка мыши';
const DELETE_POINT_HINT = 'Удалить точку из контура геозоны';

const DRAW_HOLE_KEY = 'Z + Левая кнопка мыши';
const DRAW_HOLE_HINT = 'Добавить точки внутреннеого контура (отверстия)';

// Отображает поле редактирования имени геозоны, кнопки создания/удаления геозоны
function GeoZonesToolbarWidget(props) {
  const {
    changeableGeoZone,
    selectedGeoZones,
    nameGeoZone,
    onClickDelete,
    errors,
    setErrors,
    setIsChanged,
    setNameGeoZone,
    onClickCreate,
    isCreateGeoZone,
    getGetGeoZonesFunc,
  } = props;

  return (
    <Box className={style.geoZonesToolbarWidget}>
      <Box className={style.nameGeoZone}>
        {(changeableGeoZone?.name || isCreateGeoZone) && (
          <TextField
            fullWidth
            size="small"
            id="nameGeoZone"
            label="Название геозоны"
            value={nameGeoZone}
            onChange={(e) => {
              if (errors.name) {
                setErrors((prev) => ({
                  ...prev,
                  name: false,
                }));
              }
              setIsChanged(true);
              setNameGeoZone(e.target.value);
            }}
            // onFocus={onFocusName}
            helperText={errors.name ? 'Заполните поле' : ''}
            error={errors.name}
            required
            sx={{ width: '100%' }}
            onBlur={() => {
              if (!nameGeoZone) {
                setErrors((prev) => ({
                  ...prev,
                  name: true,
                }));
              }
            }}
          />
        )}
      </Box>
      <Box className={style.controlGeoZoneButtons}>
        <IconButtonBadge disabled={isCreateGeoZone} title="Добавить геозону" onClick={() => onClickCreate()}>
          <InsertPhotoIcon />
        </IconButtonBadge>

        <ImportGeoZoneButton getGetGeoZonesFunc={getGetGeoZonesFunc} />

        <ExportGeoZone />

        <ExportDataBySensors geoZones={selectedGeoZones} />
        <DeleteButton disabled={!selectedGeoZones.length} onDelete={() => onClickDelete()} name="геозону" />
        <Tooltip
          title={
            <>
              <strong>{DRAW_FREEHAND_KEY}</strong> — {DRAW_FREEHAND_HINT}
              <br />
              <br />
              <strong>{DELETE_POINT_KEY}</strong> — {DELETE_POINT_HINT}
              <br />
              <br />
              <strong>{DRAW_HOLE_KEY}</strong> — {DRAW_HOLE_HINT}
            </>
          }
        >
          <HelpOutlineOutlinedIcon color="primary" />
        </Tooltip>
      </Box>
    </Box>
  );
}

GeoZonesToolbarWidget.propTypes = {
  changeableGeoZone: PropTypes.shape(),
  selectedGeoZones: PropTypes.arrayOf(PropTypes.shape()),
  nameGeoZone: PropTypes.string.isRequired,
  onClickCreate: PropTypes.func.isRequired,
  isCreateGeoZone: PropTypes.bool.isRequired,
  setNameGeoZone: PropTypes.func.isRequired,
  onClickDelete: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    name: PropTypes.bool.isRequired,
    polygon: PropTypes.bool.isRequired,
  }).isRequired,
  setErrors: PropTypes.func.isRequired,
  setIsChanged: PropTypes.func.isRequired,
  getGetGeoZonesFunc: PropTypes.func.isRequired,
};

GeoZonesToolbarWidget.defaultProps = {
  changeableGeoZone: null,
  selectedGeoZones: [],
};

export default GeoZonesToolbarWidget;
